import styled, { css } from 'styled-components';
import { Container, Stack } from '../components/Layout';
import { spacing } from '../tokens/spacing';
import { typography } from '../tokens/typography';
import { borders } from '../tokens/borders';

/** Shared metrics for bilingual EN/GR badges and monolingual alignment spacers. */
export const langLabelSlotStyles = css`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: ${spacing[1]} ${spacing[2]};
  border-radius: ${borders.radius.full};
  font-size: ${typography.fontSize.xs};
  font-weight: ${typography.fontWeight.semibold};
  font-family: ${typography.fontFamily.primary};
  letter-spacing: 0.02em;
  line-height: ${typography.lineHeight.normal};
  border: ${borders.width.thin} solid transparent;
  box-sizing: border-box;
`;

/**
 * Invisible spacer matching bilingual language badge height.
 * Use on monolingual fields that sit beside BilingualDoubleInput so inputs align.
 */
export const LangLabelSlot = styled.span.attrs({
  'aria-hidden': true,
})`
  ${langLabelSlotStyles}
  visibility: hidden;
  pointer-events: none;
  user-select: none;
  &::before {
    content: 'EN';
  }
`;

export const FormContainer = styled(Container)`
  max-width: 1000px;
  padding: ${spacing[10]} ${spacing[5]};
  background: ${props => props.theme.colors.gradientBackground};
  @media (max-width: 640px) {
    padding: ${spacing[8]} ${spacing[3]};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacing[6]};
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing[4]};
  align-items: start;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

/** City (bilingual, 2/3) + postal (1/3) so postal sits beside one language column. */
export const FormRowCityPostal = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: ${spacing[4]};
  align-items: start;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing[3]};
`;

export const Checkbox = styled.input`
  margin-top: ${spacing[1]};
  width: ${spacing[4]};
  height: ${spacing[4]};
  cursor: pointer;
  accent-color: ${props => props.theme.colors.primary};
`;

export const CheckboxLabel = styled.label`
  color: ${props => props.theme.colors.text};
  font-size: ${typography.fontSize.sm};
  font-family: ${typography.fontFamily.primary};
  cursor: pointer;
  line-height: ${typography.lineHeight.relaxed};
`;

export const FormButtonGroup = styled(Stack)`
  margin-top: ${spacing[8]};
  padding-top: ${spacing[8]};
  border-top: ${borders.width.thin} solid ${props => props.theme.colors.border};
`;
